import React, { JSX, useState } from "react";
import useLzFApiCall from "@lz/services/Api";
import { useLzOnMount } from "@lz/services/Hooks";
import { lzFShowSuccessMessage } from "@lz/services/Utils";
import LzXSpinner from "@lz/components/commons/Spinner";
import LzXForm from "@lz/components/forms/Form";
import LzMBase, { LzTBase } from "@lz/models/commons/Base";
import LzMConfigurations from "@lz/models/commons/Configurations";

export interface LzPPageConfigurations {
    modelRef?: LzTBase,
    ConfigsUpdateComponent?: (
        props: {
            data: LzMBase,
            onChange?: (data: LzMBase) => void,
            onInputChange?: (key: string, value: any) => void,
        }
    ) => JSX.Element,
    children?: React.ReactNode,
}

const LzXPageConfigurations = (props: LzPPageConfigurations) => {
    const [configs, setConfigs] = useState<LzMBase>(LzMBase.buildModel({}, props.modelRef || LzMConfigurations));

    const lzApiCall = useLzFApiCall();

    const load = async () => {
        const data = await lzApiCall('app-config');

        if (data && data.configs) {
            setConfigs(LzMBase.buildModel(data.configs, props.modelRef || LzMConfigurations));
        }
    };

    const handleFormSubmit: React.FormEventHandler<HTMLFormElement> = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const data = await lzApiCall('app-config', { configs: configs }, 'post');
        if (data) {
            lzFShowSuccessMessage('Configurations updated successfully!');
            return true;
        }
        return false;
    };

    const handleInputChange = (key: string, value: any) => {
        console.log('CONFIGS - handleInputChange', key, value);
        const updated = Object.assign({}, configs);
        updated[key] = value;
        setConfigs(updated);
    };

    // Call only for the first time when component is initially loaded
    useLzOnMount(() => {
        load();
    });

    if (!configs) {
        return <LzXSpinner />
    }

    const ConfigsUpdateComponent = props.ConfigsUpdateComponent;

    return (
        <React.Fragment>
            {props.children ?
                props.children
                :
                <div className={'lz-form-page lz-form-page-full lz-form-page-no-top-margin'}>

                    <LzXForm
                        submitLabel="Save Changes"
                        onSubmit={handleFormSubmit}
                        cancelLabel="Reload"
                        onCancel={load}
                    >

                        {ConfigsUpdateComponent &&
                            <ConfigsUpdateComponent
                                data={configs}
                                onChange={(data: LzMBase) => setConfigs(data)}
                                onInputChange={handleInputChange}
                            />
                        }

                    </LzXForm>

                </div>
            }
        </React.Fragment>
    );
};

export default LzXPageConfigurations;
